import { render, staticRenderFns } from "./rhWorkOrder.vue?vue&type=template&id=85b452fc"
import script from "./rhWorkOrder.vue?vue&type=script&lang=js"
export * from "./rhWorkOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports